var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1IndoorAnglePir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 41.8a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-6 6a2.5 2.5 0 103.54 0 2.5 2.5 0 00-3.58.02l.04-.02zM51 31.52a2.57 2.57 0 10.02 5.14 2.57 2.57 0 00-.02-5.14zm-7.71.86a2.5 2.5 0 10.95.187 2.502 2.502 0 00-.96-.187h.01zm-3.08 9a2.5 2.5 0 103.54 0 2.5 2.5 0 00-3.55-.02l.01.02zm.52 7a2.5 2.5 0 102.5 2.5 2.49 2.49 0 00-2.51-2.56l.01.06zm-7-13.44a2.5 2.5 0 103.53 0 2.5 2.5 0 00-3.53-.06v.06zm.54 7a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.58v.08zM33 49.51a2.57 2.57 0 10.02 5.14 2.57 2.57 0 00-.02-5.14zM17 17v46h4V25.35L27.62 32a3 3 0 005.09-2.23 3.2 3.2 0 00-.93-2.38L25.43 21H63v-4H17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Indoor_angle_PIR.6f63b97e.svg";
export { SvgG1IndoorAnglePir as ReactComponent };